<template>
	<v-app>
		<template v-if="authed || allowUnauth">
			<!-- THE app for vuetify context, do not use anywhere else -->
			<router-view />
			<!-- All template contents can be found in /views -->
			<token-manager />
		</template>
	</v-app>
</template>

<!-- Third-Party Design Resources -->
<!-- Internal Design Foundation -->
<style lang="scss">
	@import "@/design/qvo-aria.scss";
</style>

<script>
	import { mapState } from "vuex";
	import tokenManager from './qux-common/components/token-manager.vue';

	export default {
		components: {
			tokenManager
		},
		computed: {
			...mapState({
				loggedInUserId: (state) => state.account.loggedInUserId,
				tenantId: (state) => state.account.tenantId,
				activeTenantId: (state) => state.account.activeTenantId,
			}),
			authed() {
				return this.loggedInUserId && this.activeTenantId ? true : false;
			},
			allowUnauth() {
				/*
					Pages that require authorization will redirect to login.
					Otherwise, the content can be viewed directly.
						Such expections must be explicitly defined here.
					This flag does NOT enable API calls / grant data access.
				*/
				let allow = false;
				if (this.$route.name === 'UI Library') {
					allow = true;
				}
				return allow;
			},
		},
	};
</script>
